import { useEffect, useRef, useState } from 'react';

export interface TooltipProps {
	message: string,
	className?: string,
	/** 移除提示倒數時間區間(毫秒) */
	countdownTime?: number,
	/** 倒數後清除提示訊息  */
	clearMessage?: () => void;
	showMessageDoAction?: () => void;
	/** data-* 屬性 */
	dataAttribute?: {
		name: string;
		value: string | number | boolean;
	};
	icon?: () => React.ReactNode;
}

export const Tooltip = ({
	message,
	className,
	countdownTime,
	showMessageDoAction,
	clearMessage,
	dataAttribute,
	icon
}: TooltipProps) => {
	const [isShow, setIsShow] = useState(false);
	const [displayMessage, setDisplayMessage] = useState(message);
	const timerRef = useRef<ReturnType<typeof setTimeout>>();

	const showDisplayMessage = () => {
		setIsShow(true);
		setDisplayMessage(message);
		typeof showMessageDoAction === 'function' && showMessageDoAction();
	}

	const removeDisplayMessage = () => {
		setIsShow(false);
		if (countdownTime && message || !countdownTime) {
			setTimeout(() => {
				typeof clearMessage === 'function' && clearMessage();
				setDisplayMessage('');
			}, 300); // 延遲for移除提示動畫
		}
	}

	useEffect(() => {
		if (message) {
			if (timerRef.current) {
				clearTimeout(timerRef.current);
			}
			showDisplayMessage();

			if (countdownTime) {
				timerRef.current = setTimeout(() => {
					removeDisplayMessage();
				}, countdownTime);
			}
		} else {
			removeDisplayMessage();
		}

		return () => {
			if (timerRef.current) {
				clearTimeout(timerRef.current);
			}
		};
	}, [message]);

	return (
		<div
			className={className}
			data-active={isShow ? true : undefined}
			{...(dataAttribute ? { [`data-${dataAttribute.name}`]: dataAttribute.value } : {})}
		>
			{icon ? icon() : null}
			{displayMessage}
		</div>
	);
}